module.exports = {
	message: {
        // 越南
		home: {
			language: "Việt nam",
			keyword:'Từ khóa',
			hotPro:'Các sản phẩm bán nóng',
			product:'Sản phẩm chính',
			about:'Về chúng ta',
			aboutDesc:'Dịch vụ khách hàng, sự hài lòng của khách hàng',
			news:'Tin mới nhất',
			company:'Có',
			proVideo:'VIDEO quảng cáo',
			certificate:'Giấy chứng nhận',
			factory:'Nhà máy hợp tác'
		},
		about:{
			advantages:'Lợi thế của chúng ta',
			factory:'Trưng bày tại nhà máy',
			honors:'Danh dự và chứng chỉ',
			honorsDesc:'Chúng tôi theo đuổi mục tiêu phục vụ anh tốt hơn',
			title1:'Năng lực sản xuất',
			content1:'Sở hữu hoàn toàn, nhà máy sản xuất khổng lồ và hiện đại',
			title2:'Giá cả cạnh tranh',
			content2:'Giá cả hợp lý, hiệu suất chi phí cao',
			title3:'Báo động',
			content3:'Một số kho hàng nằm ở cảng bốc dỡ chính',
			title4:'Đội chuyên nghiệp',
			content4:'Chuyên nghiệp phát triển, sản xuất, xuất khẩu đội',
			free1:'Các dịch vụ theo dõi',
			frcon1:'Tái chế Kim loại đề cập đến việc xử lý vật lý hoặc cơ học các vật liệu hữu ích được tách ra từ Kim loại phế liệu thành các sản phẩm tái chế. Nó là một chuỗi công nghiệp từ tái chế, giải thể đến tái chế. Ngành công nghiệp tái chế Kim loại đã hình thành một chuỗi công nghiệp hoàn chỉnh và hệ sinh thái tái chế. Khi các nền kinh tế đang nổi lên dần áp dụng công nghệ và lối sống tương tự như các nước OECD, nhu cầu Kim loại toàn cầu trong tương lai sẽ gấp 3 đến 9 lần số lượng Kim loại được sử dụng trên toàn thế giới. Tái chế các sản phẩm Kim loại phức tạp có thể giải quyết và đối phó với những thách thức do nhu cầu Kim loại tăng lên.',
			free2:'Kiểm soát chất lượng',
			frcon2:'Thiết bị tái chế Kim loại chủ yếu bao gồm thiết bị nghiền và nghiền, phân loại thiết bị, thiết bị tiền xử lý và thiết bị tái tạo, v. V. Các thiết bị khác nhau đóng một vai trò quan trọng trong các liên kết khác nhau của tái chế Kim loại. Những thiết bị này được sử dụng rộng rãi để xử lý phế liệu Kim loại và cải thiện sử dụng tài nguyên, bao gồm nhiều phương tiện kỹ thuật khác nhau như nghiền vật lý, tách từ, phẳng, vv.',
			free3:'Hậu cần một điểm dừng',
			frcon3:'Trung tâm tái chế Kim loại nhà máy của công ty chúng tôi chuyên xử lý tất cả các loại chất thải Kim loại và cam kết tái chế và tinh chế Kim loại quý. Phạm vi tái chế tại cửa hàng bao gồm thế giới, cung cấp các dịch vụ thuận tiện như phân tích giá tại chỗ và giao dịch tiền mặt. Công ty chúng tôi tập trung vào chất thải Kim loại có hàm lượng cao (90%), có thể được tái chế bất kể trọng lượng hoặc hình dạng.',
			free4:'Kiểm tra bên thứ ba',
			frcon4:'Ngoài tác động môi trường của việc khai thác và nấu chảy Kim loại, nó cũng tiêu thụ 7% đến 8% nguồn cung năng lượng của thế giới. Tái chế tiêu thụ năng lượng ít hơn so với sản xuất Kim loại sơ cấp, trong khi giảm tác động tổng thể đến các điểm khai thác mỏ. Việc tái chế Kim loại cũng có thể làm giảm nhu cầu quặng cấp thấp, tránh khai thác một số Kim loại quý hiếm trong tương lai.',
			new1:'Tin tức',
			new2:'Tin công ty',
			new3:'Tin tức công nghiệp'
		},
		service:{
			ourservice:'Sự phục vụ của chúng ta',
			questions:'Những câu hỏi THƯỜNG gặp',
			message:'Hãy để lại lời nhắn',
			hours:'Xin cứ để lại tin nhắn. Chúng tôi sẽ trả lời anh trong 24 giờ nữa.',
			name:'Tên anh:',
			mail:'E-Mail: *',
			tel:'Điện thoại / Ứng dụng là gì:',
			type:'Loại sản phẩm: *',
			video:'Đoạn phim',
			up:'Trang trước',
			next:'Trang tiếp theo'
		},
		contact:{
			help:'Chúng tôi đến đây để giúp đỡ',
			helpDesc:'Hãy liên lạc với chúng tôi qua thông tin liên lạc sau',
			manager:'Quản lý bán hàng',
			phone:'Điện thoại / Ứng dụng là gì / Chúng ta nói chuyện',
			sendeamil:'Gửi Email',
			ouraddress:'Địa chỉ của chúng tôi'
		}, 
		foot:{
			navigation:'Chuyển hướng nhanh',
			type:'Các loại',
			mobile:'Di động(Ứng dụng là gì/húng ta nói chuyện)',
			email:'Email',
			address:'Địa chỉ',
			number:'Số tài liệu',
			service:'Dịch vụ dừng lại, chọn lọc dễ dàng'
		},
		product:{
			description:'Mô tả',
			technical:'Các thông số kỹ thuật',
			advantages:'Ưu điểm',
			related:'Những sản phẩm liên quan',
			videoDesc:'Nhà máy sản xuất sắt hợp Kim nguồn của trung quốc, chất lượng cao nhất thế giới, giá thấp nhất, cao hoa hồng, các đại lý.',
			ti1:'Xin điền vào địa chỉ email.',
			ti2:'Xin hãy điền vào mẫu.',
			ti3:'Xin điền vào nội dung.'
		},
		nav:{
			home:'Về nhà',
			about:'Về chúng ta',
			products:'Sản phẩm',
			news:'Tin tức',
			video:'Đoạn phim',
			free:'Tái chế & Công nghệ miễn phí',
			contact:'Liên lạc',
			vr:'VR',
			chat:'Tán gẫu',
			whatsapp:'Những điều quái quỷ',
			wechat:'Chúng ta nói chuyện',
			message:'Thông điệp',
			tel:'Tel',
			top:'Phía trên',
		},
		btn:{
			read:'Đọc thêm',
			news:'Tin mới đây',
			exhibition:'Thông tin thêm',
			watchVideo:'Xem thêm Đoạn phim',
			services:'Các dịch vụ',
			products:'Sản phẩm',
			contactus:'Liên lạc với chúng tôi',
			inquiry:'Thắc mắc ngay bây giờ',
			size:'Kích cỡ',
			packing:'Đóng gói',
			service:'Dịch vụ trực tuyến',
			submit:'Nộp',
			sendEmial:'Gửi EMAIL',
			now:'Bây giờ hãy trật tự',
			text1:'Đừng do dự liên lạc với chúng tôi bất cứ lúc nào.',
			text2:'Chúng tôi thiết kế nội dung và tính chi tiết của vật liệu đáp ứng nhu cầu của bạn.',
			text3:'Cho dù bạn cần tăng cường an toàn, tối đa hóa công suất sản xuất hoặc độ tin cậy, hoặc giảm chi phí, chúng tôi sẽ giao hàng.',
			text4:'Chúng tôi tận tâm cung cấp dịch vụ khách hàng đặc biệt và cung cấp sản phẩm chất lượng cao cho khách hàng có giá trị của mình.',
			text5:'Tập trung vào sản xuất Ferro Silicon và Kim loại Silicon chất lượng cao',
			text6:'Bí quyết: 1. Bạn cần sản phẩm nào? 2. Anh định làm dự án gì? 3. Khi nào bạn cần sản phẩm này?'
		}
    }
};
